import { selectCartEntries, selectMinimalCartEntries } from './cart/cart.selectors';

export const orderingSelectors = {
  // Cart selectors
  selectCartEntries,
  selectMinimalCartEntries,
};
